export enum PageEventNames {
  PAGE_VIEWED = 'pros profile - page viewed',
  CTA_CLICKED = 'pros profile - primary cta clicked',
  SHARE_CLICKED = 'pros profile - share profile clicked',
  BADGE_CLICKED = 'pros profile - badge clicked',
  CATEGORIES_MORE_CLICKED = 'pros profile - more services clicked',
  AVATAR_CLICKED = 'pros profile - profile avatar clicked',
  GALLERY_CLICKED = 'pros profile - gallery clicked'
}
